import { render } from "./ModalSuporteTrocaMunicipio.vue?vue&type=template&id=466db2ed&scoped=true"
import script from "./ModalSuporteTrocaMunicipio.vue?vue&type=script&lang=js"
export * from "./ModalSuporteTrocaMunicipio.vue?vue&type=script&lang=js"

import "./ModalSuporteTrocaMunicipio.vue?vue&type=style&index=0&id=466db2ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466db2ed"]])

export default __exports__